export default class Accordion {
    constructor() {       
        this.init();
    }

    init() {
        this.clickAndKeyboardEvents();
        this.wrapTables();
    }

    clickAndKeyboardEvents() {
        const $titles = $('.accordion-cell-title');

        const toggleAccordion = ($title) => {
            const $cell = $title.parent();
            const isExpanded = $cell.hasClass('expand');

            if (isExpanded) {
                $cell.removeClass('expand');
                $cell.children('.accordion-cell-body').stop().slideUp();
                $title.attr('aria-expanded', 'false');
            } else {
                // Close all other cells
                $cell.siblings('.accordion-cell').removeClass('expand')
                    .children('.accordion-cell-body').stop().slideUp()
                    .children('.accordion-cell-title').attr('aria-expanded', 'false');

                // Open current cell
                $cell.addClass('expand');
                $cell.children('.accordion-cell-body').stop().slideDown();
                $title.attr('aria-expanded', 'true');
            }
        };

        // Click handler
        $titles.on('click', function() {
            toggleAccordion($(this));
        });

        // Keyboard handler
        $titles.on('keydown', function(e) {
            const $current = $(this);
            const currentIndex = $titles.index($current);

            switch (e.key) {
                case 'Enter':
                case ' ':
                    e.preventDefault(); // prevent scrolling for Space
                    toggleAccordion($current);
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    $titles.eq((currentIndex + 1) % $titles.length).focus();
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    $titles.eq((currentIndex - 1 + $titles.length) % $titles.length).focus();
                    break;
                case 'Home':
                    e.preventDefault();
                    $titles.first().focus();
                    break;
                case 'End':
                    e.preventDefault();
                    $titles.last().focus();
                    break;
            }
        });
    }

    wrapTables() {
        $('.accordion-cell .accordion-cell-bodytext table td').each(function () {
            $(this).html(function(i, html){
                return html.replace(/-/g, '–&#8288;').replace(/–/g, '–&#8288;'); 
            });
        }); 

        $('.accordion-cell .accordion-cell-bodytext table').each(function () {
            $(this).wrap(function () {
                return '<div class="accordion-table-wrapper"></div>';
            });
        }); 
    }    
}
